import { render, staticRenderFns } from "./card-ui.svg.vue?vue&type=template&id=cfd21b5c&"
import script from "./card-ui.svg.vue?vue&type=script&lang=js&"
export * from "./card-ui.svg.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports